module.exports = __webpack_public_path__ + "img/result-container.93b4efc5.png";